import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course02 from "../../../course/course-02/course";
import lesson0222 from "../../course-02/lesson-22/lesson";
import lesson0223 from "../../course-02/lesson-23/lesson";
import lesson0227 from "../../course-02/lesson-27/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "eed650a5-dd72-43f8-8614-bdeca38ccb5a",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0222),
    lesson: lesson0222,
  },
  {
    id: "702323ba-6827-4db3-a1c6-9035b5db05e4",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0223),
    lesson: lesson0223,
  },
  {
    id: "a1c220bd-5f31-4573-8cfe-a0fd73f53eaa",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0227),
    lesson: lesson0227,
  },
];

export default lessonLinks;
